module.exports = __webpack_public_path__ + "static/media/cover.a8d79229.webp";